<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="vendor?.name || 'Vendor'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!loaded) {
      <ion-skeleton-text animated="true" style="height: 400px; border-radius: 6px" />
    }

    @if (loaded && vendor) {
      <tidy-card>
        <tidy-row>
          <tidy-initials-icon [fullName]="vendor.name" />
          <tidy-text
            [header]="vendor.name"
            [translate]="false" />
        </tidy-row>
        @if (vendor.vendor_category?.name) {
          <tidy-row>
            <tidy-text [helper]="vendor.vendor_category.name" [translate]="false" />
          </tidy-row>
        }
        @if (vendor.company_name) {
          <tidy-row>
            <tidy-text [body]="vendor.company_name" [translate]="false" />
          </tidy-row>
        }
        @if (vendor.email) {
          <tidy-row>
            <tidy-text [body]="vendor.email" [translate]="false" />
          </tidy-row>
        }
        @if (vendor.phone) {
          <tidy-row>
            <tidy-text [body]="vendor.phone" [translate]="false" />
          </tidy-row>
        }
        @if (vendor.address1) {
          <tidy-row>
            <tidy-text [body]="vendor.address1" [translate]="false" />
            @if (vendor.address2) {
              <tidy-text [body]="' ' + vendor.address2" [translate]="false" />
            }
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="(vendor.city || '') + ', ' + (vendor.state || '') + ' ' + (vendor.zipcode || '')" [translate]="false" />
          </tidy-row>
        }
        @if (vendor.description) {
          <tidy-row class="extra-top-padding">
            <tidy-text [helper]="'Description'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="vendor.description" [translate]="false" />
          </tidy-row>
        }
        @if (vendor.notes) {
          <tidy-row class="extra-top-padding">
            <tidy-text [helper]="'Notes'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="vendor.notes" [translate]="false" />
          </tidy-row>
        }
      </tidy-card>

      <tidy-button
        [text]="'Create Invoice'"
        [action]="boundCreateInvoice"
        class="primary" />
      <tidy-button
        [text]="'Edit Vendor'"
        [action]="boundEdit"
        class="secondary" />

      @if (invoices.length > 0) {
        <tidy-row class="extra-top-padding">
          <tidy-text [header]="'Invoices'" />
        </tidy-row>
        @for (invoice of invoices; track invoice.id) {
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text
                [body]="'Invoice #' + invoice.id"
                [translate]="false" />
              <tidy-text
                [body]="(invoice.amount / 100 | currency)"
                [translate]="false" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [helper]="invoice.full_paid ? 'Paid' : 'Pending'" />
            </tidy-row>
          </tidy-card>
        }
      }

      @if (errorMessage) {
        <tidy-error-message [text]="errorMessage" />
      }
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
